var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4EC3A3FE-710C-4449-B254-6A4A55E27BCB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.253358025 30.7433587 0.253358025 30.7433587 30.6172457 0 30.6172457"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pantalla-Entrada",
    transform: "translate(-25.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-mini",
    transform: "translate(25.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0668962,24.2404309 C28.0668962,26.2990605 26.3711962,27.9738259 24.2868337,27.9738259 L6.45640875,27.9738259 C4.37243375,27.9738259 2.67673375,26.2990605 2.67673375,24.2404309 L2.67673375,6.63013457 C2.67673375,4.57150494 4.37243375,2.89673951 6.45640875,2.89673951 L24.2868337,2.89673951 C26.3711962,2.89673951 28.0668962,4.57150494 28.0668962,6.63013457 L28.0668962,24.2404309 Z M24.2868337,0.253319753 L6.45640875,0.253319753 C2.89644625,0.253319753 -0.00011625,3.11412222 -0.00011625,6.63013457 L-0.00011625,24.2404309 C-0.00011625,27.7568259 2.89644625,30.6172457 6.45640875,30.6172457 L24.2868337,30.6172457 C27.8471837,30.6172457 30.7433587,27.7568259 30.7433587,24.2404309 L30.7433587,6.63013457 C30.7433587,3.11412222 27.8471837,0.253319753 24.2868337,0.253319753 L24.2868337,0.253319753 Z",
    id: "Fill-1",
    fill: "#00EBCF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.4777305,13.2354229 L13.6811919,13.2354229 L13.680098,12.8992788 L13.6979656,6.87810729 C13.6979656,6.62136411 13.5098088,6.4137931 13.2782593,6.4137931 L11.4911348,6.4137931 C11.2592207,6.4137931 11.0714286,6.62176717 11.0714286,6.87810729 L11.0714286,23.0533302 C11.0714286,23.3096704 11.2592207,23.5172414 11.4911348,23.5172414 L13.2782593,23.5172414 C13.5098088,23.5172414 13.6979656,23.3096704 13.6979656,23.0533302 L13.6979656,17.7068653 L13.691402,16.0966785 L18.429962,16.0966785 L18.429962,23.0533302 C18.429962,23.3096704 18.6181188,23.5172414 18.8500329,23.5172414 L20.616008,23.5172414 C20.8475575,23.5172414 21.0357143,23.3096704 21.0357143,23.0533302 L21.0357143,16.0628222 C21.0357143,14.5014046 19.8903647,13.2354229 18.4777305,13.2354229",
    id: "Fill-4",
    fill: "#0044F0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.451e8e50.svg";
export { ForwardRef as ReactComponent };